import InstallerPicker from './InstallerPicker';
export default InstallerPicker;



// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/NewConnectionRequest/InstallerPicker/index.js